export default {"src":"/_next/static/media/business-age.357c1e68.svg","height":25,"width":26};